// extracted by mini-css-extract-plugin
module.exports = {"button-container":"Button_button-container__1OYGO","button":"Button_button__1DEgw","icon-left":"Button_icon-left__2bznT","icon-right":"Button_icon-right__3ja4z"};